import { 
    GET_BRANCH_DETAIL, GET_DELIVERY_ADDRESSES, CREATE_BRANCH, UPDATE_BRANCH,
    ACTIVATE_BRANCH, DEACTIVATE_BRANCH, GET_ERRORS 
} from '../../../../actions/types';
import {
    getDeliveryAddresses, getBranchById, createBranch, updateBranch, activateBranch, deactivateBranch
} from '../../../../actions/AddressManagementActions';
import DeliveryAddressModal from './DeliveryAddressModal';
import BootstrapTable from 'react-bootstrap-table-next';
import LoadingOverlay from 'react-loading-overlay';
import Combobox from 'react-widgets/lib/Combobox';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Col, Row } from 'react-bootstrap';
import { Edit } from '@material-ui/icons';
import Card from '@material-ui/core/Card';
import { IconButton } from 'material-ui';
import React, { Component } from 'react';
import { connect } from 'react-redux';

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class DeliveryAddresses extends Component {

    state = {
        deliveryAddressModalIsVisible: false,
        showSnackBar:                  false,
        activeLoader:                  true,
		severitySnackBar:              '',
		textSnackBar:                  '',
        modalType:                     'CREATE',
        deliveryAddresses:             [],
        socialReasonSelected:          this.props.socialReasonData,
        deliveryAddressSelected:       {},
        statusSelected:                true,
        statusData:                    [
            {
                label: 'Activo',
                value: true
            },
            {
                label: 'Inactivo',
                value: false
            }
        ]
    }

    constructor(props) {
        super(props);
        this.handleCloseAlert = this.handleCloseAlert.bind(this);
        this.deactivateBranch = this.deactivateBranch.bind(this);
        this.openModalCreate  = this.openModalCreate.bind(this);
        this.activateBranch   = this.activateBranch.bind(this);
        this.onChangeStatus   = this.onChangeStatus.bind(this);
        this.createBranch     = this.createBranch.bind(this);
        this.updateBranch     = this.updateBranch.bind(this);
    }

    componentDidMount() {
        this.props.getDeliveryAddresses(this.state.socialReasonSelected._id, this.state.statusSelected);

    }

    componentDidUpdate(prevProps) {
        if (this.props.deliveryAddresses !== this.state.deliveryAddresses) {
			this.setState({
				deliveryAddresses: this.props.deliveryAddresses,
				activeLoader:      false,
			});
        } else if (this.props.actionType === GET_BRANCH_DETAIL && prevProps.actionType !== GET_BRANCH_DETAIL) {
            this.setState({
                deliveryAddressSelected:       this.props.branchDetailData,
                deliveryAddressModalIsVisible: true,
                modalType:                     'UPDATE'
            });
        } else if (this.props.actionType === CREATE_BRANCH && prevProps.actionType !== CREATE_BRANCH) {
            this.setState({
                activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Dirección creada exitosamente.',
				severitySnackBar: 'success',
			});
            this.props.getDeliveryAddresses(this.state.socialReasonSelected._id, this.state.statusSelected);
        } else if (this.props.actionType === UPDATE_BRANCH && prevProps.actionType !== UPDATE_BRANCH) {
            this.setState({
                activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Dirección actualizada exitosamente.',
				severitySnackBar: 'success',
			});
            this.props.getDeliveryAddresses(this.state.socialReasonSelected._id, this.state.statusSelected);
        } else if (this.props.actionType === ACTIVATE_BRANCH && prevProps.actionType !== ACTIVATE_BRANCH) {
            this.setState({
                activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Dirección activada exitosamente.',
				severitySnackBar: 'success',
			});
            this.props.getDeliveryAddresses(this.state.socialReasonSelected._id, this.state.statusSelected);
        } else if (this.props.actionType === DEACTIVATE_BRANCH && prevProps.actionType !== DEACTIVATE_BRANCH) {
            this.setState({
                activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Dirección desactivada exitosamente.',
				severitySnackBar: 'success',
			});
            this.props.getDeliveryAddresses(this.state.socialReasonSelected._id, this.state.statusSelected);
		} else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
            this.setState({
                activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     this.props.error,
				severitySnackBar: 'error'
			});
        }
    }

    linkActions = (cell, row, rowIndex, formatExtraData) => {
        return ([
            <Row key={rowIndex}>
                <Col xs={12} md={12} sm={12} lg={12}>
                    <IconButton size="small" style={{color:"orange"}}>
						<Edit
							key={row._id}
							onClick={() => {
                                this.getBranchDetailData(row)
							}}
						/>
					</IconButton>
                </Col>
            </Row>
        ]);
    }

    ///---------------------------------------EVENTS-------------------------------------
    
    onPressReturnSR() {
        this.props.onPressReturnSR();
    }
    
    onPressReturnToSocialReasons() {
        this.props.onPressReturnToSocialReasons();
    }
    
    handleCloseAlert = (event, reason) => {
        if (reason === "clickaway") {
            return;
		}
        
		this.setState({
            showSnackBar: false,
		});
	};

    onPressCancel = () => {
		this.setState({
			deliveryAddressModalIsVisible: false,
			deliveryAddressSelected:       {}
		})
		this.props.getDeliveryAddresses(this.state.socialReasonSelected._id, this.state.statusSelected);
	}
    
    onChangeStatus = (e) => {
        this.setState({
            statusSelected: e.value,
            activeLoader:   true
        });
        this.props.getDeliveryAddresses(this.state.socialReasonSelected._id, e.value);
    }

    openModalCreate = () => {
		this.setState({
			deliveryAddressModalIsVisible: true,
			modalType:                     'CREATE',
		});
	};

    getBranchDetailData(data) {
        this.props.getBranchById(data._id);
    }
    
    createBranch(data) {
        this.props.createBranch(data);
		this.setState({
            activeLoader:                  true,
			deliveryAddressModalIsVisible: false,
		});
    }

    updateBranch(data) {
        this.props.updateBranch(data);
		this.setState({
            activeLoader:                  true,
			deliveryAddressModalIsVisible: false,
            deliveryAddressSelected:       {}
		});
    }

    activateBranch(id) {
        this.props.activateBranch(id);
        this.setState({
            activeLoader:                  true,
			deliveryAddressModalIsVisible: false,
            deliveryAddressSelected:       {}
		});
    }

    deactivateBranch(id) {
        this.props.deactivateBranch(id);
        this.setState({
            activeLoader:                  true,
			deliveryAddressModalIsVisible: false,
            deliveryAddressSelected:       {}
		});
    }

    ///---------------------------------------VIEW-------------------------------------

    render() {
        const customOptions = {
			noDataText:
				'<div className="color-red">No hay datos disponibles para su consulta.</div>',
		};
        const columns = [
            {
                dataField: 'nombre',
				text:      'Nombre',
			},
            {
                dataField: 'direccion.estado',
                text:      'Estado',
            },
            {
                dataField: 'direccion.ciudad',
                text:      'Ciudad',
            },
            {
                dataField: 'direccion.calle',
                text:      'Calle',
            },
            {
                dataField: 'direccion.colonia',
                text:      'Colonia',
            },
            {
                dataField: 'innerBranchId',
                text:      'Inner Branch Id',
            },
            {
                dataField: 'estadoMongo',
                text:      'Estado en Mongo',
            },
            {
                dataField: 'is_active',
                text:      'Estatus',
                formatter: (cell) => (cell ? 'Activo' : 'Inactivo'),
            },
            {
                dataField: 'actions',
                text:      'Acciones',
                formatter: this.linkActions,
            }
        ]
        return (
            <div className="main-content">
                <center>
                    <div>
                        <LoadingOverlay
                            active={this.state.activeLoader}
                            isVisible={this.state.activeLoader}
                            spinner
                            text="Esto puede tardar unos minutos"
                            styles={{
                                wrapper: {
                                    width: this.state.activeLoader ? "100%" : "0%",
                                    height: this.state.activeLoader ? "100%" : "0%",
                                },
                                overlay: (base) => ({
                                    ...base,
                                    background: "rgba(10, 10, 10, 0.7)",
                                }),
                            }}
                        ></LoadingOverlay>
                        {this.state.deliveryAddressModalIsVisible &&
                            <DeliveryAddressModal
                                onPressCancel        = {this.onPressCancel}
                                deliveryAddressData  = {this.state.deliveryAddressSelected}
                                type                 = {this.state.modalType}
                                createBranch         = {this.createBranch}
                                updateBranch         = {this.updateBranch}
                                activateBranch       = {this.activateBranch}
                                deactivateBranch     = {this.deactivateBranch}
                                centers              = {this.props.centros.centros}
                                socialReasonSelected = {this.state.socialReasonSelected}
                            ></DeliveryAddressModal>
                        }
                    </div>
                    { !this.state.activeLoader &&
                        <div style={{ display: "flex", flexDirection: "column", position: "relative", alignItems: "center" }}>
                            <Row>
                                <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '0.5vh' }}>
                                    <h2 style={{ color: '#164289', 'fontWeight': 'bold' }}>Direcciones de entrega: <span style={{ color: '#000000'}}>{this.state.socialReasonSelected.nombre}</span></h2>
                                </Col>
                            </Row>
                            <div className="auth-label"></div>
                            <Row style={{width: '100%'}}>
                                <Col xs={6} md={4} sm={6} lg={4} style={{ marginTop: '0.5vh' }}>
                                    <div className="row-multiselect-roles">
                                        <Combobox
                                            className   = "select-roles"
                                            textField   = 'label'
                                            valueField  = 'value'
                                            filter      = 'contains'
                                            data        = {this.state.statusData}
                                            placeholder = "Estatus"
                                            value       = {this.state.statusSelected}
                                            onChange    = {this.onChangeStatus}
                                        />
                                    </div>
                                </Col>
                                <Col md={4} lg={4} style={{ marginTop: '0.5vh' }}></Col>
                                <Col xs={6} md={4} sm={6} lg={4} style={{ marginTop: '0.5vh' }}>
                                    <button onClick={this.openModalCreate} className="buttonGreenAdd">
                                        Agregar
                                    </button>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '3vh' }}>
                                    <div className="user-category-wrapper">
                                        { this.state.deliveryAddresses.length > 0 &&
                                            <div>
                                                <BootstrapTable
                                                    keyField='_id'
                                                    striped
                                                    hover
                                                    condensed
                                                    data={this.state.deliveryAddresses}
                                                    headerWrapperClasses="title-table"
                                                    options={customOptions}
                                                    columns={columns}
                                                />
                                            </div>
                                        }
                                        { this.state.deliveryAddresses.length === 0 &&
                                            <div style={{ display: 'block', justifyContent: 'center', alignItems: 'center'}}>
                                                <Row>
                                                    <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '1vh', marginBottom: '1vh' }}>
                                                        <Card variant="outlined" style={{padding: '8px'}}>
                                                            <h3>Sin direcciones de entrega para este usuario</h3>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                        <br/>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '3vh' }}>
                                    <button className="modal-buttonNo" onClick={this.onPressReturnToSocialReasons.bind(this)}>
                                        REGRESAR
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    }
                    <Snackbar
                        open={this.state.showSnackBar}
                        autoHideDuration={6000}
                        onClose={this.handleCloseAlert}
                    >
                        <Alert
                            onClose={this.handleCloseAlert}
                            severity={this.state.severitySnackBar}
                        >
                            {this.state.textSnackBar}
                        </Alert>
                    </Snackbar>
                </center>
            </div>
        );
    }
} 

const mapStateToProps = (state) => ({
	deliveryAddresses: state.address_management_reducer.deliveryAddresses,
    branchDetailData:  state.address_management_reducer.branchDetailData,
    actionType:        state.address_management_reducer.actionType,
    centros:           state.center_reducer,
	error:             state.address_management_reducer.error,
});

export default connect(mapStateToProps, {
    getDeliveryAddresses,
    deactivateBranch,
    activateBranch,
    getBranchById,
    createBranch,
    updateBranch,
})(DeliveryAddresses);